import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import { post } from '@alltrails/core/utils/post';
import type Coupon from '@alltrails/types/Coupon';

export default async function verify(couponCode: string, subscriptionTier?: PurchaseTier) {
  return post<Coupon[]>('/api/alltrails/coupons/verify', {
    coupon_code: couponCode,
    ...(subscriptionTier && { subscription_tier: subscriptionTier })
  });
}
